import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_dashboard/layout/core'
import { AboutListWrapper } from './AboutComponent'
import { useIntl } from 'react-intl'

const AboutPage = () => {
  const intl = useIntl()

  const AboutBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'ABOUT_PAGE.BREADCRUMB' }),
      path: '/apps/about-management/about',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='about'
          element={
            <>
              <PageTitle breadcrumbs={AboutBreadcrumbs}>
                {intl.formatMessage({ id: 'ABOUT_PAGE.TITLE' })}
              </PageTitle>
              <AboutListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/About-management/About' />} />
    </Routes>
  )
}

export default AboutPage
